/*
*初始化 web 版本友盟统计
* */
import { BOM } from './BOM';
import { Tracker } from './Tracker';

export const init = (event, label, params = {}) => {
    if (!BOM.window.trackerWeb) {
        BOM.window.trackerWeb = new Tracker(event, label, params);
    }
};
export const track = (arg1, arg2, arg3) => {
    if (BOM.window.trackerWeb) {
        BOM.window.trackerWeb.track(arg1,arg2,arg3);
    } else {
        BOM.log('trackerWeb not created');
    }
};
